export const sortKeywords = (keywords: string[]): string[] =>
  [...keywords].sort((a, b) => a.localeCompare(b));
